import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/**
 * Neutral-tone animated placeholder. Gets sized by classnames at the callsite
 * (width/height/rounded-*). Uses `--surface-2` so it blends in on both light
 * and dark themes without us needing a bespoke palette entry.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-[var(--r-sm)] bg-[color:var(--surface-2)]", className)}
      aria-hidden="true"
      {...props}
    />
  );
}
